export interface MangaChapter {
  id: string;
  title: string;
  chapterNumber: number;
  updateDate: string;
  pageCount: number;
}

export interface MangaItem {
  id: string;
  slug: string;
  title: string;
  author: string;
  coverImage: string;
  description: string;
  category: string;
  status: string;
  rating: number;
  views: number;
  updateDate: string;
  tags: string[];
  chapters: MangaChapter[];
}

export interface MangaCategory {
  slug: string;
  name: string;
  icon: string;
}

export const mangaCategories: MangaCategory[] = [
  { slug: "all", name: "全部作品", icon: "ri-grid-line" },
  { slug: "hot", name: "热门推荐", icon: "ri-fire-line" },
  { slug: "new", name: "最新上架", icon: "ri-sun-line" },
  { slug: "romance", name: "恋爱甜宠", icon: "ri-heart-line" },
  { slug: "adventure", name: "热血冒险", icon: "ri-sword-line" },
  { slug: "completed", name: "已完结", icon: "ri-check-double-line" },
];

export const mangaList: MangaItem[] = [
  {
    id: "1",
    slug: "3077-sweet-attack-season2",
    title: "3077甜蜜暴击第二季",
    author: "糖心漫画工作室",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20romance%20manga%20cover%20art%2C%20soft%20pastel%20pink%20and%20warm%20tones%2C%20young%20couple%20standing%20close%20under%20cherry%20blossom%20tree%2C%20dreamy%20atmosphere%2C%20clean%20illustration%20style%2C%20delicate%20linework%2C%20romantic%20shoujo%20manga%20aesthetic%2C%20white%20background%20with%20subtle%20floral%20elements&width=400&height=560&seq=manga-cover-01&orientation=portrait",
    description: "甜蜜暴击第二季重磅回归！在这个充满甜蜜与挑战的校园里，林小糖和陆辰风的故事继续上演。面对新的对手、新的考验，他们的感情将何去何从？青春的热血与悸动，友情的试炼与坚守，一切尽在3077甜蜜暴击第二季。",
    category: "romance",
    status: "连载中",
    rating: 9.8,
    views: 1289600,
    updateDate: "2026-08-03",
    tags: ["恋爱", "校园", "甜宠", "青春"],
    chapters: [
      { id: "ch-101", title: "第101话 重逢的时刻", chapterNumber: 101, updateDate: "2026-08-03", pageCount: 28 },
      { id: "ch-100", title: "第100话 特别的礼物", chapterNumber: 100, updateDate: "2026-07-27", pageCount: 30 },
      { id: "ch-99", title: "第99话 不安的预感", chapterNumber: 99, updateDate: "2026-07-20", pageCount: 26 },
      { id: "ch-98", title: "第98话 夏日的约定", chapterNumber: 98, updateDate: "2026-07-13", pageCount: 29 },
      { id: "ch-97", title: "第97话 心跳加速", chapterNumber: 97, updateDate: "2026-07-06", pageCount: 27 },
      { id: "ch-96", title: "第96话 意外的访客", chapterNumber: 96, updateDate: "2026-06-29", pageCount: 25 },
    ],
  },
  {
    id: "2",
    slug: "love-and-producer",
    title: "恋与制作人",
    author: "星河动漫",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20romance%20manga%20cover%2C%20elegant%20woman%20in%20modern%20office%20setting%2C%20soft%20warm%20lighting%2C%20professional%20yet%20romantic%20atmosphere%2C%20beautiful%20illustration%20with%20detailed%20background%2C%20clean%20manga%20style%2C%20shoujo%20aesthetic%2C%20white%20and%20cream%20tones&width=400&height=560&seq=manga-cover-02&orientation=portrait",
    description: "当普通的职场女孩遇到四位风格迥异的完美男神，一场关于事业与爱情的精彩故事就此展开。在繁华的都市中，她将如何平衡梦想与感情？四位男神各自隐藏的秘密又是什么？",
    category: "romance",
    status: "连载中",
    rating: 9.6,
    views: 856400,
    updateDate: "2026-08-02",
    tags: ["恋爱", "都市", "职场", "逆后宫"],
    chapters: [
      { id: "ch-56", title: "第56话 命运的转折", chapterNumber: 56, updateDate: "2026-08-02", pageCount: 32 },
      { id: "ch-55", title: "第55话 深夜的来电", chapterNumber: 55, updateDate: "2026-07-26", pageCount: 28 },
      { id: "ch-54", title: "第54话 办公室的秘密", chapterNumber: 54, updateDate: "2026-07-19", pageCount: 30 },
    ],
  },
  {
    id: "3",
    slug: "overbearing-ceo-love-me",
    title: "霸道总裁爱上我",
    author: "墨染丹青",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20romance%20manga%20cover%2C%20handsome%20man%20in%20dark%20suit%20and%20gentle%20woman%2C%20luxurious%20setting%2C%20dramatic%20lighting%2C%20romantic%20and%20intense%20atmosphere%2C%20clean%20shoujo%20manga%20style%2C%20soft%20warm%20colors%20with%20elegant%20composition%2C%20white%20background&width=400&height=560&seq=manga-cover-03&orientation=portrait",
    description: "一个是冷面霸道的集团总裁，一个是单纯倔强的普通女孩。一场契约婚姻将两个世界的人绑在一起。当真心遇上假意，当温柔融化冰冷，这段不被看好的感情将走向何方？",
    category: "romance",
    status: "已完结",
    rating: 9.5,
    views: 1567800,
    updateDate: "2026-06-15",
    tags: ["恋爱", "总裁", "契约婚姻", "甜宠"],
    chapters: [
      { id: "ch-120", title: "第120话 永远的幸福（完）", chapterNumber: 120, updateDate: "2026-06-15", pageCount: 36 },
      { id: "ch-119", title: "第119话 最后的告白", chapterNumber: 119, updateDate: "2026-06-08", pageCount: 30 },
      { id: "ch-118", title: "第118话 真相大白", chapterNumber: 118, updateDate: "2026-06-01", pageCount: 28 },
    ],
  },
  {
    id: "4",
    slug: "time-travel-princess",
    title: "穿越之王妃不好惹",
    author: "风吟漫画",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20historical%20romance%20manga%20cover%2C%20beautiful%20woman%20in%20traditional%20hanfu%20dress%2C%20ancient%20palace%20background%2C%20dramatic%20and%20elegant%20composition%2C%20soft%20warm%20golden%20lighting%2C%20detailed%20traditional%20elements%2C%20clean%20manga%20illustration%20style%2C%20cream%20background&width=400&height=560&seq=manga-cover-04&orientation=portrait",
    description: "现代女医生意外穿越成为不受宠的王妃，凭借高超医术和现代思维在古代王府混得风生水起。且看她如何手撕白莲花，智斗恶婆婆，顺便收获冰山王爷的真心。",
    category: "adventure",
    status: "连载中",
    rating: 9.4,
    views: 723500,
    updateDate: "2026-08-01",
    tags: ["穿越", "古风", "宫斗", "逆袭"],
    chapters: [
      { id: "ch-89", title: "第89话 太后的召见", chapterNumber: 89, updateDate: "2026-08-01", pageCount: 31 },
      { id: "ch-88", title: "第88话 王府危机", chapterNumber: 88, updateDate: "2026-07-25", pageCount: 29 },
      { id: "ch-87", title: "第87话 意外的盟友", chapterNumber: 87, updateDate: "2026-07-18", pageCount: 27 },
    ],
  },
  {
    id: "5",
    slug: "urban-demon-tales",
    title: "都市妖闻录",
    author: "夜幕工作室",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20supernatural%20manga%20cover%2C%20mysterious%20atmosphere%2C%20young%20protagonist%20with%20glowing%20eyes%20in%20modern%20city%20night%2C%20dark%20and%20warm%20contrasting%20tones%2C%20urban%20fantasy%20theme%2C%20clean%20illustration%20style%2C%20white%20and%20cream%20background&width=400&height=560&seq=manga-cover-05&orientation=portrait",
    description: "在这座繁华都市的阴影之中，隐藏着不为人知的妖怪世界。大学生林夜偶然获得了看见妖怪的能力，从此被卷入一个又一个诡异事件。人与妖的界限逐渐模糊，真相远比想象中更加惊人。",
    category: "adventure",
    status: "连载中",
    rating: 9.3,
    views: 612300,
    updateDate: "2026-08-03",
    tags: ["奇幻", "都市", "妖怪", "悬疑"],
    chapters: [
      { id: "ch-45", title: "第45话 镜中的世界", chapterNumber: 45, updateDate: "2026-08-03", pageCount: 34 },
      { id: "ch-44", title: "第44话 夜访旧宅", chapterNumber: 44, updateDate: "2026-07-27", pageCount: 30 },
      { id: "ch-43", title: "第43话 妖力的觉醒", chapterNumber: 43, updateDate: "2026-07-20", pageCount: 28 },
    ],
  },
  {
    id: "6",
    slug: "sword-path-supreme",
    title: "剑道独尊",
    author: "剑心文化",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20martial%20arts%20manga%20cover%2C%20young%20swordsman%20holding%20glowing%20sword%2C%20epic%20mountain%20landscape%20background%2C%20dramatic%20clouds%20and%20dynamic%20pose%2C%20action%20packed%20composition%2C%20clean%20shonen%20manga%20style%2C%20warm%20golden%20light%2C%20white%20background%20with%20subtle%20energy%20effects&width=400&height=560&seq=manga-cover-06&orientation=portrait",
    description: "少年叶尘，天生剑心，却因家族变故沦为废人。一次意外获得上古剑道传承，从此踏上逆天修行之路。一剑破万法，万剑归宗，看他如何以手中之剑，斩破一切阻碍，成就剑道独尊！",
    category: "adventure",
    status: "连载中",
    rating: 9.7,
    views: 984200,
    updateDate: "2026-08-02",
    tags: ["修仙", "热血", "剑道", "逆袭"],
    chapters: [
      { id: "ch-210", title: "第210话 剑意大成", chapterNumber: 210, updateDate: "2026-08-02", pageCount: 32 },
      { id: "ch-209", title: "第209话 九天剑阵", chapterNumber: 209, updateDate: "2026-07-26", pageCount: 30 },
      { id: "ch-208", title: "第208话 宿命对决", chapterNumber: 208, updateDate: "2026-07-19", pageCount: 31 },
    ],
  },
  {
    id: "7",
    slug: "starry-sea-guide",
    title: "星海漫游指南",
    author: "星云社",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20sci-fi%20manga%20cover%2C%20young%20astronaut%20floating%20in%20colorful%20nebula%20space%2C%20futuristic%20spaceship%20in%20background%2C%20dreamy%20cosmic%20atmosphere%2C%20soft%20warm%20star%20light%2C%20clean%20illustration%20style%2C%20white%20and%20cream%20background&width=400&height=560&seq=manga-cover-07&orientation=portrait",
    description: "公元3077年，人类已经遍布银河系。少女星野作为一名星际快递员，在一次偶然的派送任务中发现了隐藏在星海深处的惊天秘密。一段跨越星系的冒险之旅就此展开。",
    category: "adventure",
    status: "连载中",
    rating: 9.2,
    views: 445600,
    updateDate: "2026-07-30",
    tags: ["科幻", "冒险", "星际", "热血"],
    chapters: [
      { id: "ch-33", title: "第33话 黑洞边缘", chapterNumber: 33, updateDate: "2026-07-30", pageCount: 35 },
      { id: "ch-32", title: "第32话 星际迷航", chapterNumber: 32, updateDate: "2026-07-23", pageCount: 29 },
      { id: "ch-31", title: "第31话 神秘信号", chapterNumber: 31, updateDate: "2026-07-16", pageCount: 28 },
    ],
  },
  {
    id: "8",
    slug: "rebirth-strongest-supporting",
    title: "重生之最强女配",
    author: "逆袭漫画",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20romance%20manga%20cover%2C%20confident%20woman%20in%20modern%20fashionable%20dress%2C%20luxury%20urban%20setting%2C%20elegant%20and%20powerful%20vibe%2C%20soft%20warm%20lighting%2C%20clean%20shoujo%20manga%20style%2C%20rose%20pink%20accents%2C%20white%20background&width=400&height=560&seq=manga-cover-08&orientation=portrait",
    description: "苏晚晴穿越到自己正在追的漫画世界，成了注定被女主踩在脚下的恶毒女配。凭借对剧情的了解，她决定改写命运！远离男主，专心搞事业，没想到反而成了所有人都仰望的存在。",
    category: "romance",
    status: "已完结",
    rating: 9.5,
    views: 1345200,
    updateDate: "2026-05-20",
    tags: ["穿越", "女配", "逆袭", "现代"],
    chapters: [
      { id: "ch-150", title: "第150话 无悔的选择（完）", chapterNumber: 150, updateDate: "2026-05-20", pageCount: 33 },
      { id: "ch-149", title: "第149话 最后的舞台", chapterNumber: 149, updateDate: "2026-05-13", pageCount: 30 },
      { id: "ch-148", title: "第148话 真相揭晓", chapterNumber: 148, updateDate: "2026-05-06", pageCount: 28 },
    ],
  },
  {
    id: "9",
    slug: "doomsday-park",
    title: "末日乐园",
    author: "夜幕工作室",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20post%20apocalyptic%20manga%20cover%2C%20strong%20female%20protagonist%20in%20ruined%20cityscape%2C%20dramatic%20sunset%20lighting%2C%20action%20pose%20with%20weapon%2C%20intense%20survival%20atmosphere%2C%20clean%20illustration%20style%2C%20warm%20golden%20and%20amber%20tones%2C%20white%20background&width=400&height=560&seq=manga-cover-09&orientation=portrait",
    description: "一场突如其来的灾难让世界陷入混乱。林三酒在末日中挣扎求生，却意外发现这个末日世界背后隐藏着一个巨大的「乐园」系统。每个幸存者都是玩家，而通关奖励——是活下去的权利。",
    category: "adventure",
    status: "连载中",
    rating: 9.6,
    views: 789300,
    updateDate: "2026-08-03",
    tags: ["末世", "生存", "冒险", "系统"],
    chapters: [
      { id: "ch-178", title: "第178话 乐园真相", chapterNumber: 178, updateDate: "2026-08-03", pageCount: 36 },
      { id: "ch-177", title: "第177话 生死一线", chapterNumber: 177, updateDate: "2026-07-27", pageCount: 32 },
      { id: "ch-176", title: "第176话 隐藏的规则", chapterNumber: 176, updateDate: "2026-07-20", pageCount: 30 },
    ],
  },
  {
    id: "10",
    slug: "immortal-king-daily",
    title: "仙王的日常生活",
    author: "青云漫画",
    coverImage: "https://readdy.ai/api/search-image?query=Chinese%20comedy%20cultivation%20manga%20cover%2C%20young%20immortal%20in%20casual%20modern%20clothes%20mixing%20ancient%20and%20modern%20elements%2C%20humorous%20expression%2C%20bright%20and%20lively%20atmosphere%2C%20clean%20illustration%20style%2C%20warm%20and%20cheerful%20colors%2C%20white%20background&width=400&height=560&seq=manga-cover-10&orientation=portrait",
    description: "活了数万年的仙王王令，为了体验凡间生活来到现代都市。然而即使隐藏了身份和实力，他那不经意间流露的仙王气场还是引起了各方势力的注意。且看仙王大人如何在凡间过（gao）日（shi）子（qing）！",
    category: "completed",
    status: "已完结",
    rating: 9.4,
    views: 1102300,
    updateDate: "2026-04-30",
    tags: ["修仙", "搞笑", "日常", "现代"],
    chapters: [
      { id: "ch-200", title: "第200话 仙王永恒（完）", chapterNumber: 200, updateDate: "2026-04-30", pageCount: 34 },
      { id: "ch-199", title: "第199话 最后的日常", chapterNumber: 199, updateDate: "2026-04-23", pageCount: 30 },
      { id: "ch-198", title: "第198话 身份暴露", chapterNumber: 198, updateDate: "2026-04-16", pageCount: 28 },
    ],
  },
];

export const aboutPageData = {
  brandName: "36漫画网",
  brandIntro: "36漫画网成立于2020年，是国内领先的在线漫画阅读平台之一。我们致力于为广大漫画爱好者提供高品质、正版授权的漫画阅读服务，涵盖恋爱、热血、奇幻、科幻、搞笑等多个品类。平台拥有超过10万部漫画作品，日均活跃用户超过500万，是漫画爱好者不可错过的阅读圣地。",
  history: [
    { year: "2020年", event: "36漫画网正式上线，首批收录5000部漫画作品" },
    { year: "2021年", event: "用户突破100万，与国内30余家漫画工作室达成合作" },
    { year: "2022年", event: "推出移动端APP，实现PC与移动端无缝阅读体验" },
    { year: "2023年", event: "日活用户突破300万，作品库扩充至8万部" },
    { year: "2024年", event: "获得年度最佳漫画平台奖，成为行业标杆" },
    { year: "2025年", event: "AI推荐系统上线，个性化推荐精准度提升200%" },
    { year: "2026年", event: "日活突破500万，持续引领漫画阅读新风潮" },
  ],
  features: [
    { title: "海量正版", description: "超过10万部正版授权漫画，每日更新数百章节" },
    { title: "高清画质", description: "全站高清漫画画质，优化阅读体验，细节清晰呈现" },
    { title: "免费阅读", description: "大量漫画支持免费在线阅读，让好故事触手可及" },
    { title: "智能推荐", description: "基于AI的个性化推荐，精准匹配您的阅读偏好" },
    { title: "多端同步", description: "PC、手机、平板无缝切换，阅读进度实时同步" },
    { title: "社区互动", description: "热闹的漫画社区，与同好一起讨论剧情、分享感受" },
  ],
  contact: {
    email: "contact@36manhua.com",
    phone: "400-888-6666",
    address: "北京市朝阳区望京科技园区36号漫画大厦",
    wechat: "36manhua_official",
    weibo: "@36漫画网",
  },
  testimonials: [
    { name: "漫迷小李", content: "36漫画网真的是我每天必刷的网站！画质清晰、更新快，追了两年多了，体验一直很好！", rating: 5 },
    { name: "糖糖爱吃糖", content: "3077甜蜜暴击第二季在这里看真的太幸福了！无删减完整版，每一话都不舍得跳过！", rating: 5 },
    { name: "读书人小张", content: "分类做得很细致，找漫画特别方便。推荐系统也很厉害，经常能发现宝藏新作！", rating: 5 },
    { name: "漫画老司机", content: "从2020年就开始用36漫画了，见证了平台的成长。画质越来越好，作品越来越多，真心推荐！", rating: 5 },
  ],
};

export const seoData = {
  siteName: "36漫画网",
  title: "3077甜蜜暴击第二季漫画-在线免费阅读全集无删减漫画-36漫画网",
  description: "36漫画网为您呈现3077甜蜜暴击第二季漫画全集无删减版，在线免费阅读，所有章节一网打尽，享受原汁原味的完整故事，不容错过。海量正版漫画，高清画质，每日更新。",
  keywords: "3077甜蜜暴击第二季,漫画,在线免费阅读,全集无删减,36漫画网",
  url: "https://www.36manhua.com",
};